<template>
    <div class="tabtable">
        <!-- Tab links -->
        <div class="tab">
          <button v-for="tab in tab_elements" :key="tab.id" :id="tab.id + 'TabLink'" class="tablinks" @click="openTab(tab.id)">{{tab.name}}</button>
        </div>

        <!-- Tab content -->
        <div v-for="tab in tab_elements" :key="tab.id" :id="tab.id + 'Tab'" class="tabcontent">
        <!-- <p>{{tab.text}}</p> -->
          <div v-for="stage in tab.stages" :key="stage.id" class="stage">
            <h2 class="name">{{stage.name}}</h2>
            <p class="text">{{stage.text}}</p>
            <img
                alt=""
                class="pic"
                :src="stage.img_src"
              />
          </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'TabTable',
    props: ['tab_elements'],
    data () {
        return {
            active_tab: ''
        }
    },
    mounted () {
      console.log(this.tab_elements[0].id)
      this.active_tab = this.tab_elements[0].id
      document.getElementById(this.tab_elements[0].id + 'TabLink').classList.add('active')
      document.getElementById(this.tab_elements[0].id + 'Tab').style.display = 'block'
    },
    methods: {
        openTab(reference) {

        // Hide previous Tab
        document.getElementById(this.active_tab + 'Tab').style.display = "none"
        document.getElementById(this.active_tab + 'TabLink').classList.remove('active')


        // Open selected tab

        document.getElementById(reference + 'Tab').style.display = "block"
        document.getElementById(reference + 'TabLink').classList.add('active')

        this.active_tab = reference
        }
    }
}
</script>

<style lang="scss" scoped>


.tabtable {
  margin-top: 5%;

}
.tab {
  overflow: hidden;
  max-width: fit-content;

  button {
    color: #01262F;
    float: left;
    border: none;
    outline: none;
    cursor: pointer;
    padding: 14px 16px;
    transition: 0.3s;
    font-size: 1.17em;

    &.active {
      color: #FFBD00;
      background: #01262F;
    }
  }
}


/* Change background color of buttons on hover */
// .tab button:hover {
//   background-color: #ddd;
// }

/* Create an active/current tablink class */
// .tab button.active {
//   background-color: #ccc;
// }

/* Style the tab content */
.tabcontent {
  display: none;
  padding: 50px;
  // border: 1px solid #01262F;
  border-top: none;
  background: #01262F;
  min-height: 300px;
  // font-size: 1em;
  max-height: 80vh;
  overflow-y: auto;

  .stage {
    margin-top: 5%;
    .name {
      font-family: "Roboto", sans-serif;
      margin-bottom: 2%;
      color: #79bcd6;
    }

    .text {
      color: #fff;
      font-size: 1.1vw;
    }
} 

}

</style>